import React from 'react'

export const UserInfo = ({fullname, roleName}) => {
  return (
    <div>{fullname} ({roleName})</div>
  )
}
